<template>
  <div
    class="ccui-multifunctional-table-wrapper  ccui-multifunctional-table-wrapper-detail"
  >
    <div class="relation">
      <div class="relation-top">
        <el-button type="text" style="color: #4A4A4A; font-weight: 600;"
          >通过{{
            relationType == "1"
              ? "股权"
              : relationType == "3"
              ? "人员任职"
              : "联系方式"
          }}关联，共识别出
          <span style="color: red;">{{ tableData.length }}</span> 种关联关系
        </el-button>
        <div>
          <el-input-number
            v-model="num"
            @change="handleChange"
            :min="0.01"
            :max="100"
            :precision="2"
            label="持股比例%"
            v-if="relationType == '1'"
          >
          </el-input-number>
          <el-button
            type="primary"
            v-if="relationType == '1'"
            style="margin-left: 10px;"
            @click="search"
            >重新揭示</el-button
          >
          <el-button
            class="el-export-button export-button"
            type="default"
            icon="icon-ccui-export"
            style="margin-bottom:6px"
            @click="exportExcel"
          >
            导出列表
          </el-button>
        </div>
      </div>

      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" label="序号"> </el-table-column>
        <!-- <el-table-column
          v-if="relationType == '3'"
          prop="startCompanyName"
          label="关联详情"
          width="100"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="detailRelation(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column> -->
        <el-table-column
          v-if="relationType == '4'"
          prop="relatedName"
          label="关联方式详情"
          :show-overflow-tooltip="true"
          width="150"
        >
        </el-table-column>
        <el-table-column
          v-if="relationType == '4'"
          prop="contactType"
          label="关联类型"
          width="120"
        >
        </el-table-column>
        <el-table-column
          :prop="relationType == '1' ? 'startCompanyName' : 'companyName'"
          label="企业名称"
        >
        </el-table-column>
        <el-table-column
          v-if="relationType == '4'"
          prop="source"
          label="企业数据源"
        >
        </el-table-column>
        <el-table-column
          v-if="relationType == '1'"
          prop="level"
          label="关联层级"
          width="100"
        >
        </el-table-column>
        <el-table-column
          :prop="relationType == '1' ? 'endCompanyName' : 'relatedCompanyName'"
          :label="relationType == '4' ? '关联企业名称' : '关联企业'"
        >
        </el-table-column>
        <el-table-column
          v-if="relationType == '4'"
          prop="relatedSource"
          label="关联企业数据源"
        >
        </el-table-column>
        <!-- <el-table-column
          v-if="relationType == '2'"
          prop="relatedName"
          label="关联投资"
        >
        </el-table-column> -->
        <el-table-column
          v-if="relationType == '1'"
          prop="relatedName"
          label="关联股东"
        >
        </el-table-column>
        <el-table-column
          v-if="relationType == '1' || relationType == '3'"
          prop="path"
          label="关键路径"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="关系详情"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <span>
        <el-table
          :data="relationDetailData"
          style="width: 100%; height: 350px;"
        >
          <el-table-column
            prop="startCompany"
            label="企业名称"
            min-width="220"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column prop="startJob" label="任职" min-width="180">
          </el-table-column>
          <el-table-column prop="name" label="人员" min-width="130">
          </el-table-column>
          <el-table-column prop="endJob" label="任职" min-width="180">
          </el-table-column>
          <el-table-column
            prop="endCompany"
            label="企业名称"
            min-width="220"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
        </el-table>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogShow" width="30%">
      <p v-for="(item, index) in tips" :key="index">{{ item }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getWarningRelationshipList } from "@/app/sourcingFlow/api/expertEvaluation";
import { exportJsonToExcel } from "@/basa/utils/Export2Excel";
export default {
  name: "associationRelationWarning",
  components: {},
  props: {
    relationData: {
      type: Array,
      default() {
        return [];
      }
    },
    relationType: {
      type: String,
      default() {
        return "";
      }
    },
    schemeId: {
      type: String,
      default() {
        return "";
      }
    },
    packId: {
      type: String,
      default() {
        return "";
      }
    },
    packName: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      relationNum: 6,
      num: 50,
      tableData: [],
      relationDetailData: [],
      dialogVisible: false,
      dialogShow: false,
      tips: []
    };
  },
  created() {
    this.init();
  },
  watch: {
    relationData: {
      deep: true,
      handler(newVal, oldVal) {
        this.tableData = JSON.parse(JSON.stringify(newVal));
        this.tableData.forEach(item => {
          item.contactType =
            item.contactType == "M"
              ? "电话"
              : item.contactType == "A"
              ? "地址"
              : item.contactType == "E"
              ? "邮箱"
              : "";
        });
        console.log("Array changed!", this.tableData);
      }
    }
  },
  methods: {
    handleClose(done) {
      this.dialogVisible = false;
      this.relationDetailData = [];
    },
    search() {
      getWarningRelationshipList({
        schemeId: this.schemeId,
        packId: this.packId,
        type: this.relationType,
        percent: this.num,
        phaseType: "8",
        isShowLoading: true
      }).then(res => {
        console.log(res);
        if (res.data.code == "0") {
          this.tableData = res.data.data;
          this.tableData.forEach(item => {
            item.contactType =
              item.contactType == "M"
                ? "电话"
                : item.contactType == "A"
                ? "地址"
                : item.contactType == "E"
                ? "邮箱"
                : "";
          });
          if (res.data.data.tips) {
            this.dialogShow = true;
            this.tips = res.data.data.tips.split("-");
          }
        }
      });
    },
    detailRelation(row) {
      this.dialogVisible = true;
      this.relationDetailData = row.pathDetail;
    },
    init() {
      this.tableData = this.relationData;
      console.log(this.relationData, "relationData");
      this.tableData.forEach(item => {
        item.contactType =
          item.contactType == "M"
            ? "电话"
            : item.contactType == "A"
            ? "地址"
            : item.contactType == "E"
            ? "邮箱"
            : "";
      });
    },
    handleChange(value) {
      console.log(value);
    },
    //导出
    exportExcel() {
      if (this.ExcelJS) {
        this.exportDefault();
      } else {
        this.exportCompatible();
      }
    },
    async exportDefault() {
      const wb = new this.ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("供应商关联关系预警");
      ws1.views = [{ state: "frozen", ySplit: 2 }];

      ws1.addRow(["供应商关联关系预警"]);
      if (this.packName) {
        ws1.addRow([this.packName]);
      }
      let addRowList = [];
      if (this.relationType == "1") {
        ws1.addRow(["股权关联"]);
        ws1.columns = [
          { key: "id", width: 20 },
          { key: "startCompanyName", width: 50 },
          { key: "level", width: 10 },
          { key: "endCompanyName", width: 50 },
          { key: "relatedName", width: 50 },
          { key: "path", width: 100 }
        ];
        addRowList = [
          "序号",
          "企业名称",
          "关联层级",
          "关联企业",
          "关联股东",
          "关键路径"
        ];
      }
      // else if (this.relationType == "2") {
      //   ws1.addRow(["投资关联"]);
      //   ws1.columns = [
      //     { key: "id", width: 20 },
      //     { key: "startCompanyName", width: 50 },
      //     { key: "level", width: 10 },
      //     { key: "endCompanyName", width: 50 },
      //     { key: "relatedName", width: 50 },
      //     { key: "path", width: 100 }
      //   ];
      //   addRowList = [
      //     "序号",
      //     "企业名称",
      //     "关联层级",
      //     "关联企业",
      //     "关联投资",
      //     "关键路径"
      //   ];
      // }
      else if (this.relationType == "3") {
        ws1.addRow(["人员任职关联"]);
        ws1.columns = [
          { key: "id", width: 20 },
          { key: "companyName", width: 50 },
          { key: "relatedCompanyName", width: 50 },
          { key: "path", width: 100 }
        ];
        addRowList = ["序号", "企业名称", "关联企业", "关键路径"];
      } else if (this.relationType == "4") {
        ws1.addRow(["联系方式关联"]);
        ws1.columns = [
          { key: "id", width: 20 },
          { key: "relatedName", width: 30 },
          { key: "contactType", width: 30 },
          { key: "companyName", width: 55 },
          { key: "source", width: 30 },
          { key: "relatedCompanyName", width: 50 },
          { key: "relatedSource", width: 50 }
        ];
        addRowList = [
          "序号",
          "关联方式详情",
          "关联类型",
          "企业名称",
          "企业数据源",
          "关联企业名称",
          "关联企业数据"
        ];
      }
      ws1.addRow([...addRowList]).alignment = { fixed: false };
      ws1.mergeCells("A1:J1");
      console.log(this.tableData, "tableData");
      this.tableData.forEach((item, index) => {
        if (this.relationType == "1") {
          ws1.addRow([
            index + 1,
            item.startCompanyName,
            item.level,
            item.endCompanyName,
            item.relatedName,
            item.path
          ]);
        }
        // else if (this.relationType == "2") {
        //   ws1.addRow([
        //     index + 1,
        //     item.startCompanyName,
        //     item.level,
        //     item.endCompanyName,
        //     item.relatedName,
        //     item.path
        //   ]);
        // }
        else if (this.relationType == "3") {
          ws1.addRow([
            index + 1,
            item.companyName,
            item.relatedCompanyName,
            item.path
          ]);
        } else if (this.relationType == "4") {
          ws1.addRow([
            index + 1,
            item.relatedName,
            item.contactType,
            item.companyName,
            item.source,
            item.relatedCompanyName,
            item.relatedSource
          ]);
        }
      });
      ws1.getRow(2).font = { bold: true, color: { argb: "000000" } };
      ws1.getRow(2).fill = { color: { argb: "000000" } };
      ws1.getRow(1).font = { bold: true, color: { argb: "000000" } };
      ws1.getRow(1).fill = { color: { argb: "000000" } };
      ws1.getColumn(5).alignment = { vertical: "middle", horizontal: "left" };
      ws1.getColumn(6).alignment = { vertical: "middle", horizontal: "left" };
      ws1.getColumn(5).alignment = { vertical: "middle", horizontal: "left" };
      ws1.getRow(1).alignment = {
        vertical: "middle",
        horizontal: "center",
        fixed: true
      };
      ws1.getRow(2).alignment = { vertical: "middle", horizontal: "left" };
      const buf = await wb.xlsx.writeBuffer();
      this.saveAs(new Blob([buf]), "供应商关联关系预警.xlsx");
    },
    exportCompatible() {
      const header = [
        "序号",
        "供应商名称",
        "集团供应商应用情况",
        "联系人",
        "手机号码",
        "传真地址",
        "邮箱地址",
        "投标情况"
      ];
      const filterVal = [
        "id",
        "supName",
        "supType",
        // "corpSupSituation",
        "contractName",
        "mobile",
        "fax",
        "email",
        "bidFlagStr"
      ];
      const excelArr = this.tableSupply.dataone;
      let count = 0;
      const list = [];
      excelArr.forEach((val, index) => {
        list.push(val); ///
        val.forEach((itemsup, indexsup) => {
          itemsup.index = ++count;
          list.push(itemsup);
        });
      });
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel({
        header,
        data,
        filename: "供应商投标情况"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.relation-top {
  display: flex;
  justify-content: space-between;
  height: 50px;
}
.el-tabs__nav-wrap::after {
  background-color: none !important;
}
.ccui-multifunctional-table-wrapper /deep/.el-dialog {
  overflow: hidden;
  width: 50% !important;

  .el-dialog__body {
    max-height: auto !important;
    height: auto !important;
  }
}
</style>
